import Login from '../Login/Login';
import ForgetPassword from '../Login/ForgetPassword';
import ResetPassword from '../Login/ResetPassword';
import SetPassword from '../Login/SetPassword';
import OnboardSuccess from '../../../PublicPages/OnboardSuccess';
import OnboardRefresh from '../../../PublicPages/OnboardRefresh';
import OtpPage from '../Login/Otp';
import MpinLogin from '../Login/components/MpinLogin';
import CalenderConsentSuccess from '../Login/components/CalenderConsentSuccess';
import CalenderConsentFailure from '../Login/components/CalenderConsentFailure';
import { WebAppAccess } from '../../../shared/AccessDenied/WebAppAccess';

export const AuthRoutes = [
  {
    path: '/',
    title: 'Login Component',
    component: Login,
  },
  {
    path: '/forget-password',
    title: 'Forget Password',
    component: ForgetPassword,
  },
  {
    path: '/reset-password',
    title: 'Reset Password',
    component: ResetPassword,
  },
  {
    path: '/invitation',
    title: 'Set Password',
    component: SetPassword,
  },
  {
    path: '/onboarding-success',
    title: 'Onboard Success',
    component: OnboardSuccess,
  },
  {
    path: '/onboarding-refresh',
    title: 'Onboard Refresh',
    component: OnboardRefresh,
  },
  {
    path: '/verify-otp',
    title: 'Verify OTP',
    component: OtpPage,
  },
  {
    path: '/verify-pin',
    title: 'Verify Pin',
    component: MpinLogin,
  },
  {
    path: '/calender-integration-success',
    title: 'Calendar Integration Success',
    component: CalenderConsentSuccess,
  },
  {
    path: '/calender-integration-failed',
    title: 'Calendar Integration Failed',
    component: CalenderConsentFailure,
  },
  {
    path: '/web-access-denied',
    title: 'Access Denied',
    component: WebAppAccess,
  },
];
